import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

interface Props {
  subtitle: string | null;
  children: ReactNode;
  open: boolean;
  onClose: () => void;
}

const SeatsDialog = ({ subtitle, children, open, onClose }: Props) => {
  return (
    <ResponsiveDrawerDialog isOpen={open} onClose={onClose}>
      <DialogTitle>
        <Stack>
          <Typography variant="h6">
            <FormattedMessage id="event.seating.seat_selection" />
          </Typography>
          <Typography
            variant="extraSmall"
            sx={{
              fontWeight: 800,
              color: 'global01.400',
            }}
          >
            {subtitle}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </ResponsiveDrawerDialog>
  );
};

export default SeatsDialog;
